<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo">E-Express Dashboard</a>
          <el-autocomplete
            class="mobile-search"
            clearable
            suffix-icon="nc-icon nc-zoom-split"
            v-model="inputSearch"
            :fetch-suggestions="querySearch"
            placeholder="Search HAWB"
            :trigger-on-focus="false"
            :highlight-first-item="true"
            style="background-color: transparent !important;"
            @select="handleSelect"
          ></el-autocomplete>
    </div>


    <template slot="navbar-menu">
      <form @submit.prevent>
        <div class="input-group no-border">
          <el-autocomplete
            class="form-control"
            clearable
            suffix-icon="nc-icon nc-zoom-split"
            v-model="inputSearch"
            :fetch-suggestions="querySearch"
            placeholder="Search HAWB"
            :trigger-on-focus="false"
            :highlight-first-item="true"
            style="background-color: transparent !important; padding: 0px !important;"
            @select="handleSelect"
          ></el-autocomplete>
        </div>
      </form>
      <ul class="navbar-nav">
        <drop-down icon="nc-icon nc-settings-gear-65" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item btn-rotate dropdown">
          <!-- <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a> -->
          <a class="dropdown-item" @click="logout">Logout</a>
        </drop-down>
      </ul>
    </template>

    <ModalShowDetail :modals="modals" @afterModalShow="modals.notice = false"></ModalShowDetail>
  </navbar>
</template>

<script>
import Vue from "vue"
import * as _apiParcel from "@/api/parcel"
import { Table, TableColumn, Autocomplete, Input } from "element-ui"
import ModalShowDetail from "@/components/Dashboard/Views/Inventory/ModalShowDetail"
import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Autocomplete)
Vue.use(Input)

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    ModalShowDetail,
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      inputSearch: '',
      modals: {
        notice: false,
        header: '',
        content: {},
      },
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize()
    },
    logout () {
      this.$store.dispatch("$_user/ON_AUTH_STATE_CHANGEL", null);
      this.$notify({
        message: 'Logout Successfully',
        type: 'success'
      })
      this.$router.push(`/login`)
    },
    async handleSelect(item) {
      if (!item.id) {
        this.$notify({
          message: 'HAWB is not found. Please search again',
          type: 'warning'
        })
        this.inputSearch = ''
        return
      }
      try {
        const res = await _apiParcel.getDetailByID(item.id)
        this.handleShow(res.data)
      } catch (err) {
        this.inputSearch = ''
        this.$notify({
          message: err,
          type: 'danger'
        })
      }
    },
    async querySearch (queryString, cb) {
      try {
        const res = await _apiParcel.searchHAWB(queryString)
        cb(res.data ? res.data : [
          {
            id: null,
            value: "Not found"
          }
        ])
      } catch (err) {
        this.$notify({
          message: err,
          type: 'danger'
        })
      }
    },
    handleShow(data) {
      this.modals.content = data
      this.modals.header = data.hawb.toString() || '-'
      this.modals.notice = true
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    }
  }
}

</script>
<style scoped lang="scss">
.divided {
  position: relative;
  margin-top: 6px;
  border-top: 1px solid #ebeef5;
}

.mobile-search {
  display: none;
  @media screen and (max-width: 991px) {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-right: 0px !important;
    padding-left: 10px !important;
    display: block;
  }
}
</style>
